import React from 'react';
import './Style.css';
import Container from 'react-bootstrap/Container'
import CloudCheckIcon from 'mdi-react/CloudCheckIcon';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';


function formatPhone($phone) {
    return 'tel:' + $phone
}

function formatMail($mail) {
    return 'mailto:' + $mail
}

const CheckIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle">
        <polyline points="13 17 18 12 13 7" stroke="#7061ff"></polyline>
        <polyline points="6 17 11 12 6 7" stroke="#7061ff"></polyline>
    </svg>
);


function Cloudconsult2ENG() {
    return (
        <div class="cloud-contact">
            <div class="cloud-cs-contain">
                <div class="cloud-contact-header">
                    <p class="typo-21-sm typo-medium typo-white">Private Kubernetes Setup & Operations Consulting</p>
                </div>
                <div class="cloud-contact-intro">
                    <div class="cloud-contact-intro-text typo-14 purple-primary">
                        <div className='cloud-item-li'>
                            <div className='cloud-item-icon'>
                                <CheckIcon />
                            </div>
                            <div className='cloud-item-text'><p class="typo-14">Reduce costs through containerized computing resources</p></div>
                        </div>
                        <div className='cloud-item-li'>
                            <div className='cloud-item-icon'>
                                <CheckIcon />
                            </div>
                            <div className='cloud-item-text'><p class="typo-14">Consulting on development and system setup for microservice adoption</p></div>
                        </div>
                        <div className='cloud-item-li'>
                            <div className='cloud-item-icon'>
                                <CheckIcon />
                            </div>
                            <div className='cloud-item-text'><p class="typo-14">Build and support internal integrated cloud at low cost</p></div>
                        </div>
                    </div>
                    <div class="cloud-contact-intro-btn typo-14 purple-primary">
                        <button className="cloud-buton">
                            <a className="url-btn" href="https://hanbiro.com/#/en/server-hosting-signup"><p class="typo-14 typo-medium purple-primary">Register</p></a>
                        </button>
                    </div>
                </div>
            </div>
        </div>


    )
}

export default Cloudconsult2ENG;